<template>
  <div class="bbp-select"
       :class="{'bbp-select_disabled': disabled}"
       ref="bbpSelect"
       @mouseleave="closeDropdownMenu"
       v-click-outside="closeDropdownMenu"
       @keydown.esc="closeDropdownMenu"
       tabindex="0">
    <label class="bbp-select-header"
         :class="{'bbp-select-header_error': error,
                  'bbp-select-header_disabled': disabled}"
         @click.stop="clickDropMenu">
      <div class="bbp-select-header__selected" v-if="selectedText">
        {{selectedText}}
      </div>
      <div class="bbp-select-header__placeholder" v-else-if="placeholder">{{placeholder}}</div>
      <i class="bbp-icon-cross bbp-select-header__cross" v-if="clearable && selectedText" @click.stop="setValue({})"/>
      <i class="bbp-icon-arrow bbp-select-header__arrow"
         :class="{'bbp-select-header__arrow_open': dropdownOpen,
                  'bbp-select-header__arrow_disabled': disabled}"/>
      <span class="bbp-error-text bbp-select-header__error-text" v-if="error">{{error}}</span>
      <input class="bbp-select-header__selected__input bbp-input"
             :class="{
               'bbp-select-header__selected__input_active': dropdownOpen && !searchValue,
               'bbp-select-header__selected__input_introduced': searchValue
             }"
             ref="bbpSelectInput"
             v-model="searchValue"
             type="text"
             v-if="searchable && !disabled"/>
    </label>
    <div class="bbp-select__indent"/>
    <transition name="bbp-slide-select">
      <VuePerfectScrollbar class="bbp-select-dropdown"
                           ref="bbpSelectScroll"
                           @ps-scroll-down="scrollEnd"
                           :style="positionScroll"
                           v-if="options && dropdownOpen"
                           :settings="scrollSettings">
        <div class="bbp-select-dropdown__indent bbp-select-dropdown__indent_top"/>
        <div class="bbp-select-dropdown-item"
             :class="{
               'bbp-select-dropdown-item_last': index === options.length - 1,
               'bbp-select-dropdown-item_selected': item.id === selectedValue.id,
               'bbp-select-dropdown-item_with-image': image
             }"
             @click="setValue(item)"
             v-for="(item, index) in filtersOptions"
             :key="item.id"
             v-if="item">
          <img class="bbp-select-dropdown-item__image" :src="item[image] || defaultImage" v-if="image">
          {{item[label || defaultLabel]}}
        </div>
        <div>
        </div>
        <div class="bbp-select-dropdown__indent bbp-select-dropdown__indent_bot"/>
      </VuePerfectScrollbar>
    </transition>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {get, filter} from 'lodash'

export default {
  name: 'BBSelectNew',
  props: [
    'options',
    'label',
    'clearable',
    'value',
    'disabled',
    'placeholder',
    'error',
    'item',
    'viewMode',
    'image',
    'defaultImage',
    'searchable',
    'searchableBy',
    'searchableGet'
  ],
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      searchValue: '',
      dropdownOpen: false,
      defaultLabel: 'name',
      selectedValue: {},
      positionScroll: {},
      scrollSettings: {
        wheelPropagation: false
      }
    }
  },
  computed: {
    filtersOptions () {
      if (!this.searchable || !this.searchValue) {
        return this.options
      } else if (this.searchValue) {
        const regSearch = new RegExp(this.searchValue, 'gmi')
        const regSort = new RegExp('^' + this.searchValue, 'gmi')
        const filteredOptions = filter(this.options, item => regSearch.test(this.getValBySearch(item)))
        return filteredOptions.sort((a, b) => {
          return regSort.test(this.getValBySearch(b)) - regSort.test(this.getValBySearch(a))
        })
      }
    },
    selectedText () {
      return get(this.selectedValue, this.label || this.defaultLabel, '')
    }
  },
  methods: {
    getValBySearch (item) {
      return get(item, this.searchableBy, '')
    },
    scrollEnd (e) {
      this.$emit('scrollEnd')
    },
    clickDropMenu () {
      if (this.disabled) return
      this.dropdownOpen = !this.dropdownOpen
    },
    closeDropdownMenu () {
      this.searchValue = ''
      this.dropdownOpen = false
    },
    setValue (value) {
      this.searchValue = ''
      this.selectedValue = value || {}
      this.$emit('change', this.selectedValue)
      if (!this.searchable) this.dropdownOpen = false
    },
    setPositionSelect () {
      const select = this.$refs.bbpSelect
      if (select) {
        const position = select.getBoundingClientRect()
        this.positionScroll = {
          position: 'fixed',
          left: position.left + 'px',
          top: position.top + position.height + 'px',
          width: position.width + 'px'
        }
      }
    },
    setPositionSelectDefault () {
      this.positionScroll = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: 'auto'
      }
    }
  },
  watch: {
    value () {
      this.setValue(this.value)
    },
    searchValue () {
      if (this.searchableGet && typeof this.searchableGet === 'function') this.searchableGet(this.searchValue)
      const scroll = get(this.$refs, 'bbpSelectScroll.$el', '')
      if (scroll) scroll.scrollTop = 0
    },
    dropdownOpen (newVal) {
      const input = this.$refs.bbpSelectInput
      if (newVal && input) {
        this.$nextTick(() => { input.focus() })
      }
      this.dropdownOpen ? this.setPositionSelect() : this.setPositionSelectDefault()
    }
  },
  mounted () {
    this.setPositionSelect()
  },
  beforeMount () {
    this.setPositionSelectDefault()
    this.setValue(this.value)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-select {
    @include global-font;
    position: relative;
    font-size: 13px;
    line-height: 13px;
    height: 100%;
    width: 100%;
    text-transform: capitalize;

    &_disabled {
      pointer-events: none;
    }

    &-header {
      position: relative;
      display: flex;
      align-items: center;
      border: 1px solid $color-mercury;
      box-sizing: border-box;
      border-radius: 5px;
      min-height: 33px;
      padding: 7px 42px 7px 8px;
      cursor: pointer;

      &_disabled {
        background-color: rgba($color-wild-sand, 0.5);
        color: $color-silver;
      }

      &_error {
        border-color: $color-pomegranate;
      }

      &__error-text {
        top: -15px
      }

      &__selected {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &__input {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          cursor: pointer;
          border: none;
          background-color: transparent;
          transition: 0.3s;
          padding: 7px 8px 7px 8px;

          &:disabled {
            opacity: 0;
          }

          &_active {
            background-color: rgba($color-white, 0.6);
          }

          &_introduced {
            background-color: $color-white;
          }
        }
      }

      &__placeholder {
        color: $color-silver;
      }

      &__arrow {
        position: absolute;
        right: 10px;
        color: $color-accent;
        font-size: 10px;
        transition: 0.3s;
        pointer-events: none;

        &_disabled {
          color: $color-silver;
        }

        &_open {
          transform: rotate(180deg);
        }
      }

      &__cross {
        position: absolute;
        right: 25px;
        color: $color-silver;
        font-size: 12px;
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          color: $color-dusty-gray;
        }
      }
    }

    &__indent {
      height: 4px;
    }

    &-dropdown {
      position: absolute;
      left: 0;
      padding: 0 8px;
      background-color: $color-white;
      box-shadow: 0 0 12px rgba($color-black, 0.12);
      border-radius: 5px;
      width: 100%;
      max-height: 150px;
      z-index: 99;
      overflow: hidden;

      &-item {
        margin-bottom: 14px;
        transition: 0.3s;
        cursor: pointer;

        &_with-image {
          display: grid;
          grid-template-columns: 28px auto;
          grid-gap: 8px;
          align-items: center;
        }

        &:hover, &_selected {
          color: $color-accent;
        }

        &_last{
          margin-bottom: 0;
        }

        &__image {
          width: 28px;
          height: 28px;
          object-fit: cover;
          border-radius: 50%;
          background-color: $color-white;
        }
      }

      &__indent {
        position: sticky;
        height: 8px;
        width: 100%;
        background-color: $color-white;
        z-index: 2;

        &_top {
          top: 0
        }

        &_bot {
          bottom: 0;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Inputs/BBSelectNew.vue